import React from "react";
import "./Auth.scss";

interface AuthLayoutProps {
  children: React.ReactNode;
  subtitle?: string;
  title?: React.ReactNode;
}

const AuthLayout = ({ 
  children, 
  subtitle = "Welcome back!", 
  title = <React.Fragment>Log in to continue<br />creating stunning wall art.</React.Fragment> 
}: AuthLayoutProps) => {
  return (
    <div className="authContainer">
      <div className="auth_left">
        <figure className="auth_logo">
          <h2>It's My Wall</h2>
        </figure>
        <div className="auth_welcome">
          <span className="welcome_subtitle">{subtitle}</span>
          <h1 className="welcome_title">
            {title}
          </h1>
        </div>
      </div>
      <div className="auth_right">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
